import React from "react";
import PropTypes from "prop-types";

import Button from 'components/inputs/Button';


// StyleGuide = containers/modals/activation-modal

const FredEndQuizBlockModal = ({
  quiz, closeModal, onFinishSubmit, goToNextQuizBlock, unansweredItems
}) => {
  const onEndBlock = (!quiz.get('isBlockQuiz') || quiz.get('onLastQuizBlock')) ? onFinishSubmit : () => goToNextQuizBlock(quiz.get('currentQuizBlock').get('position') + 1);
  return (
    <>
      <div className="text-center mb-5">
        {unansweredItems > 0 && (
        <>Number of unanswered items in this block: <strong>{unansweredItems}.</strong>
          <br />
        </>
        )}
        If you end this block you will not be able to return.
      </div>
      <div className="row">
        <div className="col text-center">
          <Button className="py-2" styleVariant={unansweredItems > 0 ? 'red' : 'primary'} onClick={onEndBlock}>End Block</Button>
        </div>
        <div className="col text-center">
          <Button className="py-2" styleVariant={unansweredItems === 0 ? 'warning' : 'primary'} onClick={closeModal}>Remain In Block</Button>
        </div>
      </div>
    </>
  );
};

FredEndQuizBlockModal.propTypes = {
  quiz: PropTypes.object.isRequired,
  closeModal: PropTypes.func,
  onFinishSubmit: PropTypes.func,
  goToNextQuizBlock: PropTypes.func,
  unansweredItems: PropTypes.number
};

export default FredEndQuizBlockModal;
